import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["src", "alt", "bgColor", "mediaSide"];
import CUICenter from 'connect-dot-com-ui-components/Components/CUICenter/CUICenter';
import CUIImage from 'connect-dot-com-ui-components/Components/CUIImage/CUIImage';
import { jsx as _jsx } from "react/jsx-runtime";
const CUIHomepageCardImageSection = _ref => {
  let {
      src,
      alt,
      bgColor,
      mediaSide
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CUICenter, Object.assign({
    display: {
      base: 'none',
      md: 'block'
    },
    bgColor: bgColor,
    maxW: "60%",
    objectFit: "cover",
    paddingY: 8,
    paddingLeft: mediaSide === 'right' ? 6 : {
      base: 6,
      lg: 0
    },
    paddingRight: mediaSide === 'left' ? 6 : {
      base: 6,
      lg: 0
    }
  }, rest, {
    children: /*#__PURE__*/_jsx(CUICenter, {
      height: "100%",
      children: /*#__PURE__*/_jsx(CUIImage, {
        alt: alt,
        src: src
      })
    })
  }));
};
export default CUIHomepageCardImageSection;